import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseImageFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.5H18C19.933 2.5 21.5 4.067 21.5 6V18C21.5 19.933 19.933 21.5 18 21.5H6C4.067 21.5 2.5 19.933 2.5 18V6C2.5 4.067 4.067 2.5 6 2.5ZM12.5 9C12.5 10.3807 11.3807 11.5 10 11.5C8.61929 11.5 7.5 10.3807 7.5 9C7.5 7.61929 8.61929 6.5 10 6.5C11.3807 6.5 12.5 7.61929 12.5 9ZM10 10C10.5523 10 11 9.55228 11 9C11 8.44772 10.5523 8 10 8C9.44772 8 9 8.44772 9 9C9 9.55228 9.44772 10 10 10ZM17.1768 11.2374C17.0791 11.1398 16.9209 11.1398 16.8232 11.2374L10.5303 17.5303L10 18.0607L9.46967 17.5303L7.17678 15.2374C7.07914 15.1398 6.92085 15.1398 6.82322 15.2374L5.03033 17.0303C4.73744 17.3232 4.26256 17.3232 3.96967 17.0303C3.67678 16.7374 3.67678 16.2626 3.96967 15.9697L5.76256 14.1768C6.44598 13.4934 7.55402 13.4934 8.23744 14.1768L10 15.9393L15.7626 10.1768C16.446 9.49336 17.554 9.49336 18.2374 10.1768L20.0303 11.9697C20.3232 12.2626 20.3232 12.7374 20.0303 13.0303C19.7374 13.3232 19.2626 13.3232 18.9697 13.0303L17.1768 11.2374Z"
        fill={color}
      />
    </svg>
  );
};
